import styles from "../assets/styles/components/Space.module.scss";
export const Space = () => <div className={styles.space} />;
